


















import {
  createComponent,
  inject,
  onMounted,
  computed
} from "@vue/composition-api";
import DisplayUIKey from "@/components/display-ui-key";
import LoginKey from "@/components/login-key";
import ErrorMessage from "@/components/molecules/ErrorMessage.vue";

export default createComponent({
  setup() {
    const login = inject(LoginKey);
    if (!login) {
      throw new Error(`${LoginKey} is not provided`);
    }
    const displayui = inject(DisplayUIKey);
    if (!displayui) {
      throw new Error(`${DisplayUIKey} is not provided`);
    }

    const errorDialog = computed(
      () => displayui.dialogLoginError
    );

    const loginError = computed(() => login.loginError);

    // close dialog process
    const closeDialogLoginError = () => {
      displayui.closeDialogLoginError();
    };

    return {
      errorDialog,
      loginError,
      closeDialogLoginError
    };
  },
  components: {
    ErrorMessage
  }
});
